import { notifications } from '@mantine/notifications';
import { QueryClient } from '@tanstack/react-query';
import { TIME } from './constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A refused request does not become allowed by asking again. Retrying a 4xx only
      // doubles the load and the console noise, so retries are kept for the failures a
      // second attempt can actually fix - network faults and server errors.
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status;
        if (status != null && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
      staleTime: TIME.MS.MINUTE,
      gcTime: TIME.MS.MINUTE * 5,
    },
    mutations: {
      onError: (error: unknown, _variables, _context) => {
        // A mutation may reject with an outcome the caller renders itself — a save
        // that needs confirmation first, say. Those set `handled` and opt out of the
        // generic toast, so the user gets the dialog instead of a red error beside it.
        if ((error as { handled?: boolean } | null)?.handled) return;

        // An expired session is announced by its own dialog, which offers the way back.
        // A red toast beside it would only add noise to a state the user cannot act on.
        if ((error as { status?: number } | null)?.status === 401) return;

        notifications.show({
          title: 'Operation Failed',
          message: error instanceof Error ? error.message : String(error),
          color: 'red',
          position: 'top-right',
        });

        console.error('Mutation error:', error);
      },
    },
  },
});
